import { render, staticRenderFns } from "./CustomPermissionForm.vue?vue&type=template&id=3e0c297c&"
import script from "./CustomPermissionForm.vue?vue&type=script&lang=js&"
export * from "./CustomPermissionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports